import { Component, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { UserManagementService } from 'src/app/Services/UserManagement/user-management.service';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { IAttributes } from 'src/app/models/IAttributes';
import { SharedService } from 'src/app/Sharedservice/SharedService';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  ResetPasswordForm: FormGroup;
  public userDetailsInfo: IUserDetails;
  userId: string;
  resetPasswordUserId: string;
  id: string;
  result: string;
  public userDetailsById: IUserDetails;
  public salt: string;
  public securityQuestion: IAttributes[];
  SignOffClicked:boolean=true;
  constructor(private fb: FormBuilder,  private router: Router, private toastr: ToastrService, private userService: UserManagementService, private crypto: AESAlgorithm
    , private sharedService: SharedService) {

    if (sessionStorage.getItem("UserId") != null || sessionStorage.getItem("UserId") != undefined) {
      this.resetPasswordUserId=sessionStorage.getItem("UserId")
    } 
    this.getUserInfo();

   }

  ngOnInit() {

    this.ResetPasswordForm = this.fb.group({
      userName: ['', [Validators.required, Validators.pattern("^[A-Za-z0-9]+$"), Validators.maxLength(12)]],
      userId: [''],
      password: [''],
      question: [''],
      answer: ['']
    });

    this.userDetailsInfo = {
      userId: '',
      ASC: null,
      clinic: null,
      billing: null,
      userPassword: '',
      newPassword: '',
      salt: '',
      ssn: '',
      designation: '',
      lastName: '',
      middleName: '',
      firstName: '',
      userGender: '',
      userDob: null,
      maritalStatus: '',
      photo: '',
      salutation: '',
      ownQuestion: '',
      securityQuestion: '',
      securityAnswer: '',
      startDate: null,
      endDate: null,
      isDragonEnabled: null,
      isLocked: null,
      isActive: null,
      createdBy: '',
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      addressId: null,
      roleId: '',
      permissionCode: '',
      permissionId: '',
      roleName: '',
      usercarriers:[],
      fullName: '',
      dbOperation: '',
      isExternal: null,
      passwordReset: null,
      name: '',
      userAddressDetails: null,
      wrongAttempts: null,
      clinicWrongAttempts: null,
      txtColVisiblity: null,
      passwordCaseSensitivity: null,
      passwordExpiryPeriod: null,
      currentDate: null,
      serverDate: null,
      signatureSizeImage: '',
      userNameSpaceId: '',
      userUid: '',
      userUidType: '',
      userNameTypeCode: '',
      userIdentifierTypeCode: '',
      userIdentity: null,
      npiNumber: '',
      deaNumber: '',
      tinNumber: '',
      address1: '',
      address2: '',
      address3: '',
      state: '',
      city: '',
      postalCode: '',
      phone: '',
      fax: '',
      providerId: '',
      serviceLevel: '',
      userVerificationCode: '',
      userVerificationInfo: '',
      taxId: '',
      facilityId: null,
      primarySpeciality: '',
      specialityCode: '',
      suffix: '',
      email: '',
      ssProvider: null,
      spi: '',
      locationId: '',
      providerType: '',
      billingLocationId: null,
      paytoLocationId: null,
      payToProviderId: null,
      renderingLocationId: null,
      physician: null,
      supervisingProvider: '',
      isSupervising: null,
      clientId: null,
      appointmentBookingLimit: null,
      manageBillerId: '',
      claimType: '',
      taxonomy: '',
      bpPayerNames: '',
      billProvFullAdrs: '',
      payerIdsMb: '',
      payerNamesMb: '',
      isActiveForManageBiller: null,
      defaultProvider: null,
      postalCodeExt: '',
      stateCode: '',
      client: '',
      securityCode: '',
      status: '',
      staffType: '',
      activeStatus: '',
      claimTypeName:'',
      isPrescriber:null,
      userIdentify:null,
      userName: '',
      epcs:null,
      salutationName:'',
      locationIds: null,
      lstuserlocations: null,
      userLocations: '',
      checkuserSignature:null,
      selected: null,
      isdirect:false,
      directaddress:null
    }

    this.sharedService.getSecurityQuestionById(23).subscribe(data => {
      this.securityQuestion = data;
    });
  }

  userStatus: any;
  getUserDetails() {
     
    if (this.ResetPasswordForm.value.userName != '') {
      this.userId = encodeURIComponent(this.crypto.encryptor(this.ResetPasswordForm.value.userName.toLowerCase()).toString());
      this.userService.checkUserID(this.userId)
        .subscribe(data => {
          this.userStatus = data;

       
          if (this.userStatus == "1") {
            this.userService.getUserInfoByIdForReset(this.userId).subscribe(data => {
              this.userDetailsInfo = data;
              this.ResetPasswordForm.patchValue({
                userId: this.userDetailsInfo.userId,
                password: this.userDetailsInfo.userPassword,
               // question: this.userDetailsInfo.securityQuestion,
                answer: this.userDetailsInfo.securityAnswer
              });
            });

            this.userService.getUserInfoById(this.resetPasswordUserId).subscribe(data => {
              this.userDetailsById = data;
               
              this.salt = this.userDetailsById.salt;
              this.ResetPasswordForm.patchValue({
                question: this.userDetailsById.securityQuestion,
              })
             
            });
          }
          else {
            this.toastr.error("Please enter proper user name");
          }
        })
    }
    else {
      this.toastr.error("UserName cannot be Empty");
    }
  }

  resetPassword() {
    if (this.ResetPasswordForm.value.userName != '') {
      this.userId = encodeURIComponent(this.crypto.encryptor(this.ResetPasswordForm.value.userName.toLowerCase()).toString());
      this.userService.getUserInfoByIdForReset(this.userId).subscribe(data => {
        this.userDetailsInfo = data;
        this.id = this.userDetailsInfo.salt;
        this.userDetailsInfo.userPassword = this.crypto.encryptPassword("reset", this.id).toString();
        this.userDetailsInfo.userId = this.crypto.encryptor(this.ResetPasswordForm.value.userName.toLowerCase()).toString();
        this.userService.resetPassword(this.userDetailsInfo).subscribe(data => {
          this.result = data;
          this.toastr.success(this.result);
        },
          (err: any) => console.log(err));
      },
        (err: any) => console.log(err));
    }
    else {
      this.toastr.error("UserName cannot be Empty");
    }
  }

  onKeyPress(event: any) {
    const userName = event.target.value;
    if (userName.length == 0){
      this.ResetPasswordForm.reset();      
    }
  }

  clickManageUsers() {
    // this.navigateUserListComponent.emit();
    sessionStorage.setItem("DisplayCategeory", 'true');
    this.router.navigateByUrl('/AdminSecurity');
  }
  getUserInfo() {
     
    this.resetPasswordUserId = encodeURIComponent(this.crypto.encryptor(this.resetPasswordUserId).toString());
    this.userService.getUserInfoById(this.resetPasswordUserId).subscribe(data => {
      this.userDetailsById = data;
       
      this.salt = this.userDetailsById.salt;
      this.ResetPasswordForm.patchValue({
        userName: this.userDetailsById.userId,
        userId: this.userDetailsById.userId,
        password: this.userDetailsById.userPassword,
        question: this.userDetailsById.securityQuestion,
        answer: this.userDetailsById.securityAnswer
      })
      // this.userService.getUserInfoByIdForReset(this.resetPasswordUserId).subscribe(data => {
      //   this.userDetailsInfo = data;
      //   this.ResetPasswordForm.patchValue({
      //     userId: this.userDetailsInfo.userId,
      //     password: this.userDetailsInfo.userPassword,
      //     question: this.userDetailsInfo.securityQuestion,
      //     answer: this.userDetailsInfo.securityAnswer
      //   });
      // });
    });
  }

  
}